import React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import moment from "moment";

import { Tooltip } from "@mui/material";

export const ComprasListaItem = ({ ...item }) => {
  return (
    <tr className="p-tr-body-global" key={item.id}>
      <td className="text-center">
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          {item.nro_doc_justificacion !== null &&
            item.nro_doc_justificacion !== "" && (
              <Tooltip title="Justificada: tiene factura asociada">
                <span className="p-label-estado-letter">J</span>
              </Tooltip>
            )}

          {item.estado !== "pagada" && parseFloat(item.total_pagado) > 0 && (
            <Tooltip title="Abonado: tiene abono realizado">
              <span className="p-label-estado-letter ms-1">A</span>
            </Tooltip>
          )}

          <Tooltip title="Tipo documento: Factura">
            <span className="p-box-tipo-doc ms-1">F</span>
          </Tooltip>

          <span className="ms-1">#{item.numero || "00000"}</span>
        </Link>
      </td>
      <td className="text-center">
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          <div className="d-flex justify-content-center">
            {item.estado === "emitida" && (
              <span className="p-label-estado p-emitida">Emitida</span>
            )}
            {item.estado === "pagada" && (
              <span className="p-label-estado p-pagada">Pagada</span>
            )}
            {item.estado === "anulada" && (
              <span className="p-label-estado p-anulada">Anulada</span>
            )}
          </div>
        </Link>
      </td>
      <td className="text-center">
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          {moment(item.fecha_emision).format("DD-MM-YYYY")}
        </Link>
      </td>
      {/*  <td className="text-center">
                <Link className='LinkTable' to={`/gastos/compras/${item.id}`} >
                    {item.fecha_vencimiento ? moment(item.fecha_vencimiento).format('DD-MM-YYYY') : '--'}
                </Link>
            </td> */}
      <td className="text-start">
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          {item.razon_social || "---"}
        </Link>
      </td>
      <td>
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          <p className="max-w-60 text-left">{item.referencia}</p>
        </Link>
      </td>
      <td>
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          {item.referencia_origen ? (
            <p className="max-w-60 text-left">
              {item.origen === "ventas" ? "Neg" : "GG"} -{" "}
              {item.referencia_origen}
            </p>
          ) : (
            "Sin info."
          )}
        </Link>
      </td>
      {/* <td className="text-end">
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          <NumberFormat
            value={item.monto_base ? parseFloat(item.monto_base) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link className="LinkTable" to={`/gastos/compras/${item.id}`}>
          <NumberFormat
            value={item.total_impuesto ? parseFloat(item.total_impuesto) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td> */}
      <td className="text-end">
        <Link
          className="text-orange-600 hover:text-orange-600 font-semibold tracking-wide"
          to={`/gastos/compras/${item.id}`}
        >
          <NumberFormat
            value={item.total_compra ? parseFloat(item.total_compra) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link
          className="text-green-600 hover:text-green-600 font-semibold tracking-wide"
          to={`/gastos/compras/${item.id}`}
        >
          <NumberFormat
            value={item.total_pagado ? parseFloat(item.total_pagado) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
      <td className="text-end">
        <Link
          className="text-red-600 hover:text-red-600 font-semibold tracking-wide"
          to={`/gastos/compras/${item.id}`}
        >
          <NumberFormat
            value={item.total_por_pagar ? parseFloat(item.total_por_pagar) : 0}
            displayType={"text"}
            thousandSeparator={item.separacion_miles}
            decimalSeparator={item.separacion_decimales}
            prefix={`${item.simbolo} `}
            decimalScale={2}
            fixedDecimalScale={2}
          />
        </Link>
      </td>
    </tr>
  );
};
